module.exports = __webpack_public_path__ + "img/traffic-light-slow.7e0e1ec5.svg";